import { render, staticRenderFns } from "./ReceivePcn.vue?vue&type=template&id=7f7082ea&scoped=true&"
import script from "./ReceivePcn.vue?vue&type=script&lang=js&"
export * from "./ReceivePcn.vue?vue&type=script&lang=js&"
import style0 from "./ReceivePcn.vue?vue&type=style&index=0&id=7f7082ea&prod&lang=css&"
import style1 from "./ReceivePcn.vue?vue&type=style&index=1&id=7f7082ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7082ea",
  null
  
)

export default component.exports